export default "__VITE_ASSET__400879fb__"